export { SubheadingBlockEditor } from './SubheadingBlockEditor';
export type { SubheadingBlockEditorProps } from './types';
